let fbqReady = false;

export default function facebookPixel(userConfig = {}) {

  const FB_STANDARD_EVENTS = [
    'ViewContent',
    'AddToCart',
    'AddToWishlist',
    'InitiateCheckout',
    'AddPaymentInfo',
    'Purchase',
    'Lead',
    'CompleteRegistration',
    'Contact',
    'Search',
    'CustomEvent'
  ]

  const config = {
    options: { autoConfig: true, debug: true },
    ...userConfig
  };

  return {
    name: 'facebook',
    config,

    /**
     * Injects Facebook Pixel script and initializes the pixel
     */
    initialize: ({ config }) => {
      const { pixelId, options } = config;
      if (!pixelId || fbqReady) return;

      /* Load standard Facebook Pixel script */
      ;(function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      /* Initialize Pixel */
      window.fbq('init', pixelId, options);
      fbqReady = true;
    },

    /**
     * Track a page view
     */
    page: () => {
      if (!fbqReady) return;
      window.fbq('track', 'ViewContent');
    },

    /**
     * Track a custom event
     */
    track: ({ payload }) => {
      if (!fbqReady) return;
      const { event, properties } = payload;
      if (FB_STANDARD_EVENTS.includes(event)) {
        window.fbq('track', event, properties);
      } else {
        window.fbq('trackCustom', event, properties);
      }
    },

    /**
     * Identify a user (no-op, FB Pixel doesn't support identify)
     */
    identify: () => {},

    /**
     * Return whether the pixel script has loaded
     */
    loaded: () => fbqReady
  };
}